module.exports = __webpack_public_path__ + "static/media/mention-commentaire.912b3604.png";